import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const SecEmeaCutoverAus = () => (
  <div style={{ paddingBottom: '10px', marginBottom: '12px' }}>
    <TextStyled bold appearance='body1'>
      <TranslatedCopy id='termsConditions.section.notice' />
    </TextStyled>
    <TextStyled>
      <TranslatedCopy id='outages.systemUpgrade.notice' />
    </TextStyled>
    <br />
    <TextStyled bold style={{ textDecoration: 'underline' }}>
      <TranslatedCopy id='outages.systemUpgrade.users.emea' />
    </TextStyled>
    <TextStyled bold display='inline'>
      December 29, 10am – 2pm AEDT
    </TextStyled>
    <TextStyled display='inline'> - Full Site Outage</TextStyled>
    <br />
    <TextStyled>There will be no access to the GAMEDAY site during this time.</TextStyled>
  </div>
);

export default SecEmeaCutoverAus;
